import { GA_PREFIX } from "constants.js";
import TagManager from "react-gtm-module";

const init = (trackingID) => {
    const tagManagerArgs = {
        gtmId: trackingID,
        events: {
            sendUserInfo: "userInfo",
        },
    };
    TagManager.initialize(tagManagerArgs);
};

export const setDataLayer = async (props) => {
    try {
        const tagManagerArgs = {
            dataLayer: {
                ...(props || {}),
            },
        };

        TagManager.dataLayer(tagManagerArgs);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
};

const triggerEvent = (event) => {
    const { eventCategory, eventAction, params } = event;

    const dataLayer = {
        event: eventCategory,
        event_category: eventCategory,
        event_action: eventAction,
        event_label: JSON.stringify(params),
    };

    setDataLayer(dataLayer);
};

export const events = {
    // Cliente Existente
    existingClient: {
        eventCategory: `${GA_PREFIX}existing_client`,
        eventAction: "existing client",
        params: { now: new Date() },
    },
    // Iniciar Sesión - Step 1
    loginStep1: {
        eventCategory: `${GA_PREFIX}login_step_1`,
        eventAction: "login step 1",
        params: {
            now: new Date(),
        },
    },
    // Iniciar Sesión - Step 2
    loginStep2: {
        eventCategory: `${GA_PREFIX}login_step_2`,
        eventAction: "login step 2",
        params: {
            now: new Date(),
        },
    },
    // Registrarme
    registry0: {
        eventCategory: `${GA_PREFIX}enrollment_start`,
        eventAction: "enrollment start",
        params: {
            porcentaje: "0",
            now: new Date(),
        },
    },
    // OB Informativo
    registry1: {
        eventCategory: `${GA_PREFIX}onboarding_information`,
        eventAction: "onboarding information",
        params: {
            porcentaje: "2",
            now: new Date(),
        },
    },
    // Permisos Celular
    registry2: {
        eventCategory: `${GA_PREFIX}cellphone_permissions`,
        eventAction: "cellphone permissions",
        params: {
            porcentaje: "4",
            now: new Date(),
        },
    },
    // Datos de la Empresa
    registry3: {
        eventCategory: `${GA_PREFIX}company_data`,
        eventAction: "company data",
        params: {
            porcentaje: "12",
            now: new Date(),
        },
    },
    // INVALID CUIT
    invalidCUIT: (type) => ({
        eventCategory: `${GA_PREFIX}invalid_CUIT`,
        eventAction: "invalid CUIT",
        params: {
            errorType: type,
        },
    }),
    // Validación de Celular y Mail
    registry4: {
        eventCategory: `${GA_PREFIX}mail_validation`,
        eventAction: "mail validation",
        params: {
            porcentaje: "16",
            now: new Date(),
        },
    },
    // VU - Indicaciones validación identidad
    registry5: {
        eventCategory: `${GA_PREFIX}VU_instructions`,
        eventAction: "VU instructions",
        params: {
            porcentaje: "18",
            now: new Date(),
        },
    },
    // VU validacion exitosa
    vuSuccess: {
        eventCategory: `${GA_PREFIX}VU_success`,
        eventAction: "VU success",
        params: {},
    },
    // Personas Físicas (Datos Personales + Datos Regulatorios)
    registry6: (actividad, provincia, pep) => ({
        eventCategory: `${GA_PREFIX}personal_data`,
        eventAction: "personal data",
        params: {
            porcentaje: "26",
            now: new Date(),
            actividad,
            provincia,
            pep,
        },
    }),
    // // Datos Regulatorios
    // registry7: (pep) => ({
    //     eventCategory: `${GA_PREFIX}regulatory_data`,
    //     params: {
    //         porcentaje: "32",
    //         now: new Date(),
    //         pep,
    //     },
    // }),

    // Credenciales
    registry8: {
        eventCategory: `${GA_PREFIX}credentials`,
        eventAction: "credentials",
        params: {
            porcentaje: "34",
            now: new Date(),
        },
    },
    // Imagen de Seguridad
    registry9: {
        eventCategory: `${GA_PREFIX}security_image`,
        eventAction: "security image",
        params: {
            porcentaje: "36",
            now: new Date(),
        },
    },
    // Login
    // registry10: {
    //     eventCategory: `${GA_PREFIX}registry_10`,
    //     params: {
    //         porcentaje: "38",
    //         now: new Date(),
    //     },
    // },

    // Campaña
    registry11: {
        eventCategory: `${GA_PREFIX}offers`,
        eventAction: "offers",
        params: {
            porcentaje: "40",
            now: new Date(),
        },
    },
    // Pasos a Seguir
    registry12: {
        eventCategory: `${GA_PREFIX}legal_person_steps`,
        eventAction: "legal person steps",
        params: {
            porcentaje: "42",
            now: new Date(),
        },
    },
    // Datos de la Empresa Generales
    registry13: (pais, provincia, fatca, economicGroup, numberOfCompanies, SO) => ({
        eventCategory: `${GA_PREFIX}legal_person_general_data`,
        eventAction: "legal person general data",
        params:
            economicGroup === "si"
                ? {
                      porcentaje: "50",
                      now: new Date(),
                      pais,
                      provincia,
                      fatca,
                      economicGroup,
                      numberOfCompanies,
                      SO,
                  }
                : {
                      porcentaje: "58",
                      now: new Date(),
                      pais,
                      provincia,
                      fatca,
                      economicGroup,
                      SO,
                  },
    }),
    // // Datos de la Empresa Adicionales
    // registry14: (fatca, economicGroup, numberOfCompanies, SO) => ({
    //     eventCategory: `${GA_PREFIX}legal_person_additional_data`,
    //     params:
    //         economicGroup === "si"
    //             ? {
    //                   porcentaje: "58",
    //                   now: new Date(),
    //                   fatca,
    //                   economicGroup,
    //                   numberOfCompanies,
    //                   SO,
    //               }
    //             : {
    //                   porcentaje: "58",
    //                   now: new Date(),
    //                   fatca,
    //                   economicGroup,
    //                   SO,
    //               },
    // }),
    // Datos de la Empresa Impositivos
    registry15: (MiPYME, ganancias, IVA, IIBB, sellos) => ({
        eventCategory: `${GA_PREFIX}tax_data`,
        eventAction: "tax data",
        params: {
            porcentaje: "66",
            now: new Date(),
            MiPYME,
            ganancias,
            categoriaGanancias: ganancias === "si" ? "Inscripto" : "",
            IVA,
            categoriaIVA: IVA === "si" ? "Inscripto" : "",
            IIBB,
            sellos,
        },
    }),
    // Declaración Representante Legal
    registry16: (firmante, pep, pais, fatca) => ({
        eventCategory: `${GA_PREFIX}legal_representative_data`,
        eventAction: "legal representative data",
        params: {
            porcentaje: "72",
            now: new Date(),
            firmante,
            pep,
            pais,
            fatca,
        },
    }),
    // Declaración de Socios
    registry17: (firmante) => ({
        eventCategory: `${GA_PREFIX}shareholders_data`,
        eventAction: "shareholders data",
        params: {
            porcentaje: "78",
            now: new Date(),
            firmante,
        },
    }),
    // Declaración de Apoderados
    registry18: {
        eventCategory: `${GA_PREFIX}proxies_data`,
        eventAction: "proxies data",
        params: {
            porcentaje: "84",
            now: new Date(),
        },
    },
    // Declaración de Beneficiarios Finales
    registry19: {
        eventCategory: `${GA_PREFIX}final_beneficiaries_data`,
        eventAction: "final beneficiaries data",
        params: {
            porcentaje: "90",
            now: new Date(),
        },
    },
    // Documentación de la Empresa
    registry20: {
        eventCategory: `${GA_PREFIX}company_documentation`,
        eventAction: "company documentation",
        params: {
            porcentaje: "94",
            now: new Date(),
        },
    },
    // Página Resumen
    registry21: {
        eventCategory: `${GA_PREFIX}legal_person_finish_steps`,
        eventAction: "legal person finish steps",
        params: {
            porcentaje: "98",
            now: new Date(),
        },
    },
    // Continuar Proceso
    // registryContinue: {
    //     eventCategory: `${GA_PREFIX}registry_continue`,
    //     params: {
    //         now: new Date(),
    //     },
    // },
    // Recuperar Contraseña
    passRecovery: {
        eventCategory: `${GA_PREFIX}pass_recovery`,
        eventAction: "pass recovery",
        params: {
            now: new Date(),
        },
    },
    // Firmantes - Permisos Celular
    firmRegistry0: {
        eventCategory: `${GA_PREFIX}signer_cellphone_permissions`,
        eventAction: "signer cellphone permissions",
        params: {
            porcentaje: "0",
            now: new Date(),
        },
    },
    // Firmantes - Datos de la Empresa
    // firmRegistry1: {
    //     eventCategory: `${GA_PREFIX}signer_company_data`,
    //     params: {
    //         porcentaje: "20",
    //         now: new Date(),
    //     },
    // },
    // Firmantes - Validación de Celular y Mail
    firmRegistry2: {
        eventCategory: `${GA_PREFIX}signer_mail_validation`,
        eventAction: "signer mail validation",
        params: {
            porcentaje: "40",
            now: new Date(),
        },
    },
    // Firmantes - VU - Indicaciones validación identidad
    firmRegistry3: {
        eventCategory: `${GA_PREFIX}signer_VU_instructions`,
        eventAction: "signer VU instructions",
        params: {
            porcentaje: "50",
            now: new Date(),
        },
    },
    // Firmantes - VU validacion exitosa
    signerVuSuccess: {
        eventCategory: `${GA_PREFIX}signer_VU_success`,
        eventAction: "signer VU success",
        params: {},
    },
    // Firmantes - Datos Persona Física + Datos Regulatorios
    firmRegistry4: (nacionalidad, actividad, provincia, fatca, pep) => ({
        eventCategory: `${GA_PREFIX}signer_personal_data`,
        eventAction: "signer personal data",
        params: {
            porcentaje: "70",
            now: new Date(),
            nacionalidad,
            actividad,
            provincia,
            fatca,
            pep,
        },
    }),
    // // Firmantes - Datos Regulatorios
    // firmRegistry5: (fatca, pep) => ({
    //     eventCategory: `${GA_PREFIX}signer_regulatory_data`,
    //     params: {
    //         porcentaje: "90",
    //         now: new Date(),
    //         fatca,
    //         pep,
    //     },
    // }),

    // Firmantes - Aviso Envío de Mail
    firmRegistry6: {
        eventCategory: `${GA_PREFIX}signer_enrollment_finish`,
        eventAction: "signer enrollment finish",
        params: {
            porcentaje: "95",
            now: new Date(),
        },
    },
    accountRequest1: (productType, periodicity) => ({
        eventCategory: `${GA_PREFIX}account_request_1`,
        eventAction: "account request 1",
        params: {
            productType,
            periodicity,
        },
    }),
    accountRequest2: (productType, periodicity) => ({
        eventCategory: `${GA_PREFIX}account_request_2`,
        eventAction: "account request 2",
        params: {
            productType,
            periodicity,
        },
    }),
    newAccount: ({ productType, periodicity, destination, modalities }) => ({
        eventCategory: `${GA_PREFIX}new_account`,
        eventAction: "Nueva Cuenta",
        params: {
            productType,
            periodicity,
            destination,
            modalities,
        },
    }),
    newFixed: ({ productType, term, action }) => ({
        eventCategory: `${GA_PREFIX}new_fixed`,
        eventAction: "Nuevo Plazo Fijo",
        params: {
            productType,
            term,
            action,
        },
    }),
    newCheckbook: ({ echeqs, quantity }) => ({
        eventCategory: `${GA_PREFIX}new_checkbook`,
        eventAction: "Nueva Chequera",
        params: {
            echeqs,
            quantity,
        },
    }),
    newEcheq: ({ character, mode }) => ({
        eventCategory: `${GA_PREFIX}new_echeq`,
        eventAction: "Emisión Echeq",
        params: {
            character,
            mode,
        },
    }),
    newTransfer: () => ({
        eventCategory: `${GA_PREFIX}new_transfer`,
        eventAction: "Transferencia",
        params: {},
    }),
    newPayment: () => ({
        eventCategory: `${GA_PREFIX}new_payment`,
        eventAction: "Pago",
        params: {},
    }),
    newLoan: () => ({
        eventCategory: `${GA_PREFIX}new_loan`,
        eventAction: "Nueva Préstamo",
        params: {},
    }),

    echeq_simular: ({ datetime, montoTotal, cantChequesSeleccionados }) => ({
        eventCategory: `${GA_PREFIX}echeq_simular`,
        eventAction: "Simular",
        params: { datetime, montoTotal, cantChequesSeleccionados },
    }),
    echeq_confirmar: ({ datetime, echeqs, plazoPromedio, Id_lote }) => ({
        eventCategory: `${GA_PREFIX}echeq_confirmar`,
        eventAction: "Confimar",
        params: {
            datetime,
            // echeqs: [id_cheque, monto, montoAcreditar],
            echeqs,
            plazoPromedio,
            Id_lote,
        },
    }),
    echeq_enviar: () => ({
        eventCategory: `${GA_PREFIX}echeq_enviar`,
        eventAction: "Enviar",
        params: {},
    }),
    echeq_firmar: () => ({
        eventCategory: `${GA_PREFIX}echeq_firmar`,
        eventAction: "Firmar",
        params: {},
    }),
    echeq_filtrar: () => ({
        eventCategory: `${GA_PREFIX}echeq_filtrar`,
        eventAction: "Filtrar",
        params: {},
    }),
    echeq_descargar: () => ({
        eventCategory: `${GA_PREFIX}echeq_descargar`,
        eventAction: "Descargar",
        params: {},
    }),
    echeq_negociar_aprobados: ({ datetime, echeqs, plazoPromedio, Id_lote }) => ({
        eventCategory: `${GA_PREFIX}echeq_negociar_aprobados`,
        eventAction: "Negociar Aprobados",
        params: {
            datetime,
            // echeqs: [id_cheque, monto, montoAcreditar, estado],
            echeqs,
            plazoPromedio,
            Id_lote,
        },
    }),
    prestamo_solicitar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_solicitar`,
        eventAction: "Solicitar",
        params: {},
    }),
    prestamo_detalle: ({ estado, id_prestamo, totalCuota, impuestos, intereses }) => ({
        eventCategory: `${GA_PREFIX}prestamo_detalle`,
        eventAction: "Detalle",
        params: { estado, id_prestamo, totalCuota, impuestos, intereses },
    }),
    prestamo_descargar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_descargar`,
        eventAction: "Descargar",
        params: {},
    }),
    prestamo_cancelacion_anticipada: () => ({
        eventCategory: `${GA_PREFIX}prestamo_cancelacion_anticipada`,
        eventAction: "Cancelación Antitipada",
        params: {},
    }),
    prestamo_cancelar_prestamo: ({
        numPrestamo,
        moneda,
        tea,
        capitalOriginal,
        capitalAdeudado,
        comisionCancelación,
        iva,
        montoCancelar,
    }) => ({
        eventCategory: `${GA_PREFIX}prestamo_cancelar_prestamo`,
        eventAction: "Cancelar Préstamo",
        params: { numPrestamo, moneda, tea, capitalOriginal, capitalAdeudado, comisionCancelación, iva, montoCancelar },
    }),
    prestamo_cancelar_prestamo_enviar: ({ cuentaAcreditación, cuentaDebito }) => ({
        eventCategory: `${GA_PREFIX}prestamo_cancelar_prestamo_enviar`,
        eventAction: "Enviar Cancelación",
        params: { cuentaAcreditación, cuentaDebito },
    }),
    prestamo_cancelar_firmar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_cancelar_firmar`,
        eventAction: "Firmar Cancelación",
        params: {},
    }),
    prestamo_cancelar_descargar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_cancelar_descargar`,
        eventAction: "Cancelación Descarcar",
        params: {},
    }),
    prestamo_detallecuota_descargar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_detallecuota_descargar`,
        eventAction: "Detalle Cuota Descargar",
        params: {},
    }),
    prestamo_nuevo_simular: ({ cliente, linea, destinoFondos, moneda, importe, periodicidad, cantCuotas }) => ({
        eventCategory: `${GA_PREFIX}prestamo_nuevo_simular`,
        eventAction: "Solicitud Nuevo Prestamo",
        params: { cliente, linea, destinoFondos, moneda, importe, periodicidad, cantCuotas },
    }),
    prestamo_nuevo_simluacion: ({
        primeraCuotaPura,
        gastosOtorgamiento,
        moneda,
        tna,
        tem,
        cftConIva,
        cft,
        cuentaAcreditacion,
        cuentaDebito,
    }) => ({
        eventCategory: `${GA_PREFIX}prestamo_nuevo_simluacion`,
        eventAction: "Simulación Nuevo Préstamo",
        params: {
            primeraCuotaPura,
            gastosOtorgamiento,
            moneda,
            tna,
            tem,
            cftConIva,
            cft,
            cuentaAcreditacion,
            cuentaDebito,
        },
    }),
    prestamo_nuevo_confirmar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_nuevo_confirmar`,
        eventAction: "Confirmación Nuevo Préstamo",
        params: {},
    }),
    prestamo_nuevo_enviar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_nuevo_enviar`,
        eventAction: "Enviar Solicitud Nuevo Prestamo",
        params: {},
    }),
    prestamo_nuevo_solicitud_descargar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_nuevo_solicitud_descargar`,
        eventAction: "Descargar Solicitud Nuevo Prestamo",
        params: {},
    }),
    prestamo_nuevo_solicitud_firmar: () => ({
        eventCategory: `${GA_PREFIX}prestamo_nuevo_solicitud_firmar`,
        eventAction: "Firmar Solicitud Nuevo Prestamo",
        params: {},
    }),
    cuentas_transferir_entre_cuentas: () => ({
        eventCategory: `${GA_PREFIX}cuentas_transferir_entre_cuentas`,
        eventAction: "Trasnferir entre cuentas",
        params: {},
    }),
    cuentas_transferir_terceros: () => ({
        eventCategory: `${GA_PREFIX}cuentas_transferir_terceros`,
        eventAction: "Transferir a terceros",
        params: {},
    }),
    cuentas_pagar_servicios: () => ({
        eventCategory: `${GA_PREFIX}cuentas_pagar_servicios`,
        eventAction: "Pagar Servicios",
        params: {},
    }),
    cuentas_emitir_echeq: () => ({
        eventCategory: `${GA_PREFIX}cuentas_emitir_echeq`,
        eventAction: "Emitir Echeq",
        params: {},
    }),
    cuentas_ver_acuerdo: () => ({
        eventCategory: `${GA_PREFIX}cuentas_ver_acuerdo`,
        eventAction: "Ver Acuerdo",
        params: {},
    }),
    cuentas_nueva: () => ({
        eventCategory: `${GA_PREFIX}cuentas_nueva`,
        eventAction: "Nuevo Acuerdo",
        params: {},
    }),
    cuentas_baja: () => ({
        eventCategory: `${GA_PREFIX}cuentas_baja`,
        eventAction: "Baja de Cuenta",
        params: {},
    }),
    cuentas_detalle_movimientos_descargar: () => ({
        eventCategory: `${GA_PREFIX}cuentas_detalle_movimientos_descargar`,
        eventAction: "Detalle Movimiento Descargar",
        params: {},
    }),
    cuentas_info_detalle: () => ({
        eventCategory: `${GA_PREFIX}cuentas_info_detalle`,
        eventAction: "Información Detalle",
        params: {},
    }),
    cuentas_detalle_compartir: () => ({
        eventCategory: `${GA_PREFIX}cuentas_detalle_compartir`,
        eventAction: "Detalle Compartir",
        params: {},
    }),
    cuentas_detalle_descargar: () => ({
        eventCategory: `${GA_PREFIX}cuentas_detalle_descargar`,
        eventAction: "Detalle Descargar",
        params: {},
    }),
    cuentas_detalle_QR: () => ({
        eventCategory: `${GA_PREFIX}cuentas_detalle_QR`,
        eventAction: "Detalle QR",
        params: {},
    }),
    cuentas_edicion_alias: () => ({
        eventCategory: `${GA_PREFIX}cuentas_edicion_alias`,
        eventAction: "Editar Alias",
        params: {},
    }),
    cuentas_saldos_historicos: () => ({
        eventCategory: `${GA_PREFIX}cuentas_saldos_historicos`,
        eventAction: "Saldos Históricos",
        params: {},
    }),
    cuentas_solicitud: ({ numCuenta, tipoCuenta, periodicidad, destino, otro, modalidades, mensaje }) => ({
        eventCategory: `${GA_PREFIX}cuentas_solicitud`,
        eventAction: "Solicitud de Cuenta",
        params: { numCuenta, tipoCuenta, periodicidad, destino, otro, modalidades, mensaje },
    }),
    cuentas_solicitud_enviar: () => ({
        eventCategory: `${GA_PREFIX}cuentas_solicitud_enviar`,
        eventAction: "Solicitud de Cuenta Enviar",
        params: {},
    }),
    cuentas_solicitud_firmar: () => ({
        eventCategory: `${GA_PREFIX}cuentas_solicitud_firmar`,
        eventAction: "Solicitud de Cuenta Firmar",
        params: {},
    }),
    cuentas_solicitud_descargar: () => ({
        eventCategory: `${GA_PREFIX}cuentas_solicitud_descargar`,
        eventAction: "Solicitud de Cuenta Descargar",
        params: {},
    }),
    pf_detalle_descargar: () => ({
        eventCategory: `${GA_PREFIX}pf_detalle_descargar`,
        eventAction: "Detalle PF Descargar",
        params: {},
    }),
    pf_listado_descargar: () => ({
        eventCategory: `${GA_PREFIX}pf_listado_descargar`,
        eventAction: "Listado PF Descargar",
        params: {},
    }),
    pf_cancelar_renovacion_auto: ({ id_plazo_fijo }) => ({
        eventCategory: `${GA_PREFIX}pf_cancelar_renovacion_auto`,
        eventAction: "Cancelar Renovación",
        params: { id_plazo_fijo },
    }),
    pf_cancelar_renovacion_auto_firmar: () => ({
        eventCategory: `${GA_PREFIX}pf_cancelar_renovacion_auto_firmar`,
        eventAction: "Cancelar Renovación Firmar",
        params: {},
    }),
    pf_cancelar_renovacion_auto_descargar: () => ({
        eventCategory: `${GA_PREFIX}pf_cancelar_renovacion_auto_descargar`,
        eventAction: "Cancelar Renovación Descargar",
        params: {},
    }),
    pf_nuevo_simular: ({ tipo, capital, plazo, accion }) => ({
        eventCategory: `${GA_PREFIX}pf_nuevo_simular`,
        eventAction: "Nuevo PF Simulación",
        params: { tipo, capital, plazo, accion },
    }),
    pf_nuevo_constituir: () => ({
        eventCategory: `${GA_PREFIX}pf_nuevo_constituir`,
        eventAction: "Nuevo PF Constituir",
        params: {},
    }),
    pf_nuevo_constituir_enviar: ({ monto, cbu }) => ({
        eventCategory: `${GA_PREFIX}pf_nuevo_constituir_enviar`,
        eventAction: "Nuevo PF Constituir Enviar",
        params: { monto, cbu },
    }),
    pf_nuevo_constituir_firmar: () => ({
        eventCategory: `${GA_PREFIX}pf_nuevo_constituir_firmar`,
        eventAction: "Nuevo PF Constituir Firmar",
        params: {},
    }),
    pf_nuevo_constituir_descargar: () => ({
        eventCategory: `${GA_PREFIX}pf_nuevo_constituir_descargar`,
        eventAction: "Nuevo PF Constituir Descargar",
        params: {},
    }),
    pf_historicos_descarga: () => ({
        eventCategory: `${GA_PREFIX}pf_historicos_descarga`,
        eventAction: "PF Históricos Descarga",
        params: {},
    }),
    pf_consulta_tasas: () => ({
        eventCategory: `${GA_PREFIX}pf_consulta_tasas`,
        eventAction: "PF consulta de Tasa",
        params: {},
    }),
    trans_mis_cuentas_enviar: () => ({
        eventCategory: `${GA_PREFIX}trans_mis_cuentas_enviar`,
        eventAction: "Enviar",
        params: {},
    }),
    trans_mis_cuentas_firmar: () => ({
        eventCategory: `${GA_PREFIX}trans_mis_cuentas_firmar`,
        eventAction: "Firmar",
        params: {},
    }),
    trans_mis_cuentas_descargar: () => ({
        eventCategory: `${GA_PREFIX}trans_mis_cuentas_descargar`,
        eventAction: "Descargar",
        params: {},
    }),
    programar: ({ frecuencia }) => ({
        eventCategory: `${GA_PREFIX}programar`,
        eventAction: "Programar Transferencia",
        params: { frecuencia },
    }),
    trans_pagos_enviar: ({ tipoPago, cantOrdenesPago }) => ({
        eventCategory: `${GA_PREFIX}trans_pagos_enviar`,
        eventAction: "Pagos Enviar",
        params: { tipoPago, cantOrdenesPago },
    }),
    trans_pagos_firmar: () => ({
        eventCategory: `${GA_PREFIX}trans_pagos_firmar`,
        eventAction: "Pagos Firmar",
        params: {},
    }),
    trans_pagos_descargar: () => ({
        eventCategory: `${GA_PREFIX}trans_pagos_descargar`,
        eventAction: "Pagos Descargar",
        params: {},
    }),
    debin_pagar: () => ({
        eventCategory: `${GA_PREFIX}debin_pagar`,
        eventAction: "Pagar Debin",
        params: {},
    }),
    debin_rechazar: () => ({
        eventCategory: `${GA_PREFIX}debin_rechazar`,
        eventAction: "Rechazar Debin",
        params: {},
    }),
    debin_pausar: () => ({
        eventCategory: `${GA_PREFIX}debin_pausar`,
        eventAction: "Pausar Debin",
        params: {},
    }),
    debin_pausar_enviar: () => ({
        eventCategory: `${GA_PREFIX}debin_pausar_enviar`,
        eventAction: "Pausar Debin Enviar",
        params: {},
    }),
    debin_eliminar: () => ({
        eventCategory: `${GA_PREFIX}debin_eliminar`,
        eventAction: "Eliminar Debin",
        params: {},
    }),
    debin_activar: () => ({
        eventCategory: `${GA_PREFIX}debin_activar`,
        eventAction: "Activar Debin",
        params: {},
    }),
    debin_adherir_recurrencia_enviar: () => ({
        eventCategory: `${GA_PREFIX}debin_adherir_recurrencia_enviar`,
        eventAction: "Adherir Recurrencia Enviar",
        params: {},
    }),
    debin_adherir_recurrencia_firmar: () => ({
        eventCategory: `${GA_PREFIX}debin_adherir_recurrencia_firmar`,
        eventAction: "Adherir Recurrencia Firmar",
        params: {},
    }),
    debin_adherir_recurrencia_descargar: () => ({
        eventCategory: `${GA_PREFIX}debin_adherir_recurrencia_descargar`,
        eventAction: "Adherir Recurrencia Descargar",
        params: {},
    }),
    debin_adherir_cuentas_enviar: () => ({
        eventCategory: `${GA_PREFIX}debin_adherir_cuentas_enviar`,
        eventAction: "Adherir Cuentas Enviar",
        params: {},
    }),
    debin_eliminar_recurrencia: () => ({
        eventCategory: `${GA_PREFIX}debin_eliminar_recurrencia`,
        eventAction: "Eliminar Recurrencia",
        params: {},
    }),
    debin_pausar_recurrencia: () => ({
        eventCategory: `${GA_PREFIX}debin_pausar_recurrencia`,
        eventAction: "Pausar Recurrencia",
        params: {},
    }),
    debin_solicitar_enviar: ({ monto }) => ({
        eventCategory: `${GA_PREFIX}debin_solicitar_enviar`,
        eventAction: "Solicitar Debin Enviar",
        params: { monto },
    }),
    debin_solicitar_descargar: () => ({
        eventCategory: `${GA_PREFIX}debin_solicitar_descargar`,
        eventAction: "Solicitar Debin Descargar",
        params: {},
    }),
    debin_solicitar_recurrencia_enviar: ({ servicio }) => ({
        eventCategory: `${GA_PREFIX}debin_solicitar_recurrencia_enviar`,
        eventAction: "Solicitar Recurrencia Enviar",
        params: { servicio },
    }),
    debin_solicitar_recurrencia_firmar: () => ({
        eventCategory: `${GA_PREFIX}debin_solicitar_recurrencia_firmar`,
        eventAction: "Solicitar Recurrencia Firmar",
        params: {},
    }),
    debin_solicitar_recurrencia_descargar: () => ({
        eventCategory: `${GA_PREFIX}debin_solicitar_recurrencia_descargar`,
        eventAction: "Solicitar Recurrencia Descargar",
        params: {},
    }),
    debin_adherir_cuentas: () => ({
        eventCategory: `${GA_PREFIX}debin_adherir_cuentas`,
        eventAction: "Adherir Cuentas Debin",
        params: {},
    }),
    pagoServicio_pagar: ({ empresa }) => ({
        eventCategory: `${GA_PREFIX}pagoServicio_pagar`,
        eventAction: "Nuevo Pago - Pagar",
        params: { empresa },
    }),
    pagoServicio_descargar: () => ({
        eventCategory: `${GA_PREFIX}pagoServicio_descargar`,
        eventAction: "Nuevo Pago - Descargar",
        params: {},
    }),
    fce_transmitir_enviar: ({ tipo, tipoBeneficiario }) => ({
        eventCategory: `${GA_PREFIX}fce_transmitir_enviar`,
        eventAction: "Transfmitir Enviar",
        params: { tipo, tipoBeneficiario },
    }),
    fce_transmitir_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_transmitir_firmar`,
        eventAction: "Transfmitir Firmar",
        params: {},
    }),
    fce_transmitir_descagar: () => ({
        eventCategory: `${GA_PREFIX}fce_transmitir_descagar`,
        eventAction: "Transfmitir Descargar",
        params: {},
    }),
    fce_anular_trans_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_anular_trans_enviar`,
        eventAction: "Anular Transmición Enviar",
        params: {},
    }),
    fce_anular_trans_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_anular_trans_firmar`,
        eventAction: "Anular Transmición Firmar",
        params: {},
    }),
    fce_anular_trans_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_anular_trans_descargar`,
        eventAction: "Anular Transmición Descargar",
        params: {},
    }),
    fce_admitir_trans_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_admitir_trans_enviar`,
        eventAction: "Adminir Transmición Enviar",
        params: {},
    }),
    fce_admitir_trans_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_admitir_trans_firmar`,
        eventAction: "Adminir Transmición Firmar",
        params: {},
    }),
    fce_admitir_trans_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_admitir_trans_descargar`,
        eventAction: "Adminir Transmición Descargar",
        params: {},
    }),
    fce_repudiar_trans_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_repudiar_trans_enviar`,
        eventAction: "Repudiar Transmición Enviar",
        params: {},
    }),
    fce_repudiar_trans_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_repudiar_trans_firmar`,
        eventAction: "Repudiar Transmición Firmar",
        params: {},
    }),
    fce_repudiar_trans_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_repudiar_trans_descargar`,
        eventAction: "Repudiar Transmición Descargar",
        params: {},
    }),
    fce_informar_cbu_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_informar_cbu_enviar`,
        eventAction: "Informar / Modificar CBU Enviar",
        params: {},
    }),
    fce_informar_cbu_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_informar_cbu_firmar`,
        eventAction: "Informar / Modificar CBU Firmar",
        params: {},
    }),
    fce_informar_cbu_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_informar_cbu_descargar`,
        eventAction: "Informar / Modificar CBU Descargar",
        params: {},
    }),
    fce_admitir_devolucion_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_admitir_devolucion_enviar`,
        eventAction: "Admitir devolución Enviar",
        params: {},
    }),
    fce_admitir_devolucion_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_admitir_devolucion_firmar`,
        eventAction: "Admitir devolución Firmar",
        params: {},
    }),
    fce_admitir_devolucion_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_admitir_devolucion_descargar`,
        eventAction: "Admitir devolución Descagar",
        params: {},
    }),
    fce_repudiar_solicitd_devolucion_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_repudiar_solicitd_devolucion_enviar`,
        eventAction: "Repudiar solicitud de Devolución Enviar",
        params: {},
    }),
    fce_repudiar_solicitd_devolucion_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_repudiar_solicitd_devolucion_firmar`,
        eventAction: "Repudiar solicitud de Devolución Firmar",
        params: {},
    }),
    fce_repudiar_solicitd_devolucion_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_repudiar_solicitd_devolucion_descargar`,
        eventAction: "Repudiar solicitud de Devolución Descargar",
        params: {},
    }),
    fce_negociar_imf_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_negociar_imf_enviar`,
        eventAction: "Negociar en IMF Enviar",
        params: {},
    }),
    fce_negociar_imf_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_negociar_imf_firmar`,
        eventAction: "Negociar en IMF Firmar",
        params: {},
    }),
    fce_negociar_imf_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_negociar_imf_descargar`,
        eventAction: "Negociar en IMF Descargar",
        params: {},
    }),
    fce_solicitar_devolucion_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_solicitar_devolucion_enviar`,
        eventAction: "Solicitar Devolución Enviar",
        params: {},
    }),
    fce_solicitar_devolucion_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_solicitar_devolucion_firmar`,
        eventAction: "Solicitar Devolución Firmar",
        params: {},
    }),
    fce_solicitar_devolucion_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_solicitar_devolucion_descargar`,
        eventAction: "Solicitar Devolución Descargar",
        params: {},
    }),
    fce_anular_solicitud_devolucion_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_anular_solicitud_devolucion_enviar`,
        eventAction: "Anular Solicitud Devolución Enviar",
        params: {},
    }),
    fce_anular_solicitud_devolucion_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_anular_solicitud_devolucion_firmar`,
        eventAction: "Anular Solicitud Devolución Firmar",
        params: {},
    }),
    fce_anular_solicitud_devolucion_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_anular_solicitud_devolucion_descargar`,
        eventAction: "Anular Solicitud Devolución Descargar",
        params: {},
    }),
    fce_informar_modificar_cbu_enviar: () => ({
        eventCategory: `${GA_PREFIX}fce_informar_modificar_cbu_enviar`,
        eventAction: "Informar / Modificar CBU Enviar",
        params: {},
    }),
    fce_informar_modificar_cbu_firmar: () => ({
        eventCategory: `${GA_PREFIX}fce_informar_modificar_cbu_firmar`,
        eventAction: "Informar / Modificar CBU Firmar",
        params: {},
    }),
    fce_informar_modificar_cbu_descargar: () => ({
        eventCategory: `${GA_PREFIX}fce_informar_modificar_cbu_descargar`,
        eventAction: "Informar / Modificar CBU Descargar",
        params: {},
    }),
    pagos_pagar_enviar: ({ empresa, modalidadPago }) => ({
        eventCategory: `${GA_PREFIX}pagos_pagar_enviar`,
        eventAction: "Pago de Servicios  - Pagar - Enviar",
        params: { empresa, modalidadPago },
    }),
    pagos_pagar_firmar: () => ({
        eventCategory: `${GA_PREFIX}pagos_pagar_firmar`,
        eventAction: "Pago de Servicios  - Pagar - Firmar",
        params: {},
    }),
    pagos_pagar_descargar: () => ({
        eventCategory: `${GA_PREFIX}pagos_pagar_descargar`,
        eventAction: "Pago de Servicios  - Pagar - Descargar",
        params: {},
    }),
    pagos_servicios_enviar: ({ formulario }) => ({
        eventCategory: `${GA_PREFIX}pagos_servicios_enviar`,
        eventAction: "Pago de Servicios - ARCA - Enviar",
        params: { formulario },
    }),
    pagos_servicios_firmar: () => ({
        eventCategory: `${GA_PREFIX}pagos_servicios_firmar`,
        eventAction: "Pago de Servicios - ARCA - Firmar",
        params: {},
    }),
    pagos_servicios_descargar: () => ({
        eventCategory: `${GA_PREFIX}pagos_servicios_descargar`,
        eventAction: "Pago de Servicios - ARCA - Descargar",
        params: {},
    }),
    pagos_servicios_adheridos: () => ({
        eventCategory: `${GA_PREFIX}pagos_servicios_adheridos`,
        eventAction: "Pagos - Servicios Adheridos",
        params: {},
    }),
    pagos_recargas: () => ({
        eventCategory: `${GA_PREFIX}pagos_recargas`,
        eventAction: "Pagos - Recargas",
        params: {},
    }),
    pagos_realizar_nuevo_pago: () => ({
        eventCategory: `${GA_PREFIX}pagos_realizar_nuevo_pago`,
        eventAction: "Pagos - Realizar Nuevo Pago",
        params: {},
    }),
    pagos_desvincular: ({ empresa }) => ({
        eventCategory: `${GA_PREFIX}pagos_desvincular`,
        eventAction: "Pagos - Desvincular",
        params: { empresa },
    }),
};

export default {
    init,
    triggerEvent,
    events,
};
